import AEYLLogo from '@/assets/branding/workforce/aeyl-logo.png';

const colors = {
  // Brand colors
  brand_primary: '#48813C',
  brand_primary_hover: '#3A6A2F',
  brand_primary_highlight: '#A2D991',
  brand_primary_mid: '#5D9B4E',
  brand_primary_dark: '#25421E',
  brand_secondary: '#3E6C32',
  brand_accent_start: '#5A944E',
  brand_accent_end: '#4A76C9',
  brand_accent_light_start: '#EEF7E8',
  brand_accent_light_end: '#E2E9FB',
  brand_complementary_accent: 'rgb(163,34,191)',
  brand_auth_gradient_mid: '#3E6C32',
  brand_auth_gradient_end: '#25421E',
  brand_auth_warp_mid: '#5D9B4E',
};

export default {
  name: 'Assistiv',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AEYLLogo,
  colors,
};
